import { render, staticRenderFns } from "./WikiPageCategoryCreate.vue?vue&type=template&id=2338cb3c"
import script from "./WikiPageCategoryCreate.vue?vue&type=script&lang=ts"
export * from "./WikiPageCategoryCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports